import { Box, Card, Text, Button, Flex } from "@chakra-ui/react";
import LPB from "@/assets/LoginPageBackground.png";
import { AppColors } from "@/styles/colors";
import { LogoAndBadge } from "./components/LogoAndBadge";
import { useAuth } from "@/hooks/useAuth";
import { toaster } from "@/components/ui/toaster";
import { AppRoutes } from "@/constants/routes";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import AlertInfo from "@/assets/icons/alert-info.svg";
import { ProgressCircleComponent } from "@/components/progress/progress-circle";

export const LoginPage = () => {
  const { login } = useAuth();

  const navigate = useNavigate();
  const [sign, setSign] = useState<boolean>(false);

  const handleLogin = async () => {
    try {
      setSign(true);
      const response = await login();

      setSign(false);
      if (response) {
        toaster.create({
          title: "Sesión iniciada con éxito",
          type: "success",
        });
      } else {
        throw new Error("Error al iniciar sesión");
      }

      navigate(AppRoutes.HOME);
    } catch (error) {
      console.error("Error en login:", error);
      toaster.create({
        title: "Hubo un error al iniciar sesión.",
        type: "error",
      });
      navigate(AppRoutes.LOGIN)
    }
  };

  return (
    <div data-testid="login-page">
      {sign ? (
        <Flex
          flexDir="column"
          alignItems="center"
          justifyContent="center"
          w="100vw"
          h="100vh"
          gap="50px"
        >
          <ProgressCircleComponent size="sm" />

          <Text
            fontWeight={400}
            fontSize={{ xlDown: "16px", "2xl": "24px" }}
            lineHeight="24px"
            data-testid="active-d-text"
          >
            Esperando validación de Active Directory
          </Text>

          <Flex
            gap="12px"
            bgColor={AppColors.LIGHT_BLUE}
            borderRadius="10px"
            paddingX="16px"
            paddingY="12px"
          >
            <img src={AlertInfo} alt="info-alert" />
            <Text fontWeight={400} fontSize={{ xlDown: "16px", "2xl": "24px" }}>
              Esta página se actualizará automáticamente una vez se haya
              iniciado sesión con Active Directory.
            </Text>
          </Flex>
        </Flex>
      ) : (
        <Box
          w="100vw"
          h="100vh"
          position="relative"
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="100px"
          paddingTop={{ md: "60px", lg: "80px", xl: "100px" }}
        >
          <Box
            position="absolute"
            top="0"
            left="0"
            w="100%"
            h="100%"
            bg="rgba(0, 0, 0, 0.5)"
            zIndex={1}
          />

          {/* Imagen de fondo */}
          <Box
            w="100%"
            h="100%"
            bgImage={`url(${LPB})`}
            bgSize="cover"
            bgRepeat="no-repeat"
            position="absolute"
            top="0"
            left="0"
            zIndex={0}
          />

          {/* Componente con el logo y el badge */}
          <LogoAndBadge />

          {/* Caja blanca para el login */}
          <Card.Root
            bg="white"
            p={8}
            borderRadius="lg"
            boxShadow="lg"
            textAlign="center"
            zIndex={2}
          >
            <Card.Body>
              <Flex flexDir="column" gap="30px">
                <Text fontWeight={500} fontSize={{ xl: "24px", md: "20px" }}>
                  ¡Bienvenido al BackOffice de Unión Digital!
                </Text>
                <Button
                  variant="subtle"
                  bgColor={AppColors.GREEN_PRIMARY}
                  onClick={handleLogin}
                  disabled={sign}
                  data-testid="login-button"
                >
                  <Text
                    fontWeight={600}
                    fontSize={{ xl: "20px", md: "16px" }}
                    color="white"
                    padding={1}
                  >
                    Ingresar
                  </Text>
                </Button>
              </Flex>
            </Card.Body>
          </Card.Root>
        </Box>
      )}
      {/* Overlay con opacidad */}
    </div>
  );
};
